import type { LucideIcon } from 'lucide-react';
import { CreditCard, LayoutDashboard, Monitor, Rocket, ScrollText, Settings, ShieldCheck, Star, Users } from 'lucide-react';
import type { Permission } from '../api/types';
import type { TranslationKey } from '../i18n';

export type ZoneId = 'dashboard' | 'fleet' | 'people' | 'policies' | 'audit' | 'satisfaction' | 'deployment' | 'billing' | 'settings';

export interface NavItem {
  id: ZoneId;
  path: string;
  icon: LucideIcon;
  labelKey: TranslationKey;
  /** Permission(s) requise(s) pour voir la zone ; absent = visible par tous. */
  permission?: Permission | Permission[];
  /** `any` : une seule permission suffit. */
  mode?: 'all' | 'any';
}

/** Zones de la console (plan §2). L'ordre est celui de la barre latérale. */
export const NAV_ITEMS: NavItem[] = [
  { id: 'dashboard', path: '/', icon: LayoutDashboard, labelKey: 'nav.dashboard' },
  { id: 'fleet', path: '/fleet', icon: Monitor, labelKey: 'nav.fleet', permission: 'devices.read' },
  { id: 'people', path: '/people', icon: Users, labelKey: 'nav.people', permission: 'members.read' },
  { id: 'policies', path: '/policies', icon: ShieldCheck, labelKey: 'nav.policies', permission: 'policies.read' },
  { id: 'audit', path: '/audit', icon: ScrollText, labelKey: 'nav.audit', permission: ['audit.read', 'sessions.read'], mode: 'any' },
  { id: 'satisfaction', path: '/satisfaction', icon: Star, labelKey: 'nav.satisfaction', permission: 'ratings.read' },
  { id: 'deployment', path: '/deployment', icon: Rocket, labelKey: 'nav.deployment', permission: 'deployment.manage' },
  { id: 'billing', path: '/billing', icon: CreditCard, labelKey: 'nav.billing', permission: 'billing.read' },
  { id: 'settings', path: '/settings', icon: Settings, labelKey: 'nav.settings', permission: 'settings.read' },
];
